/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CampaignOverview } from './CampaignOverview';
import {
    CampaignOverviewFromJSON,
    CampaignOverviewFromJSONTyped,
    CampaignOverviewToJSON,
    CampaignOverviewToJSONTyped,
} from './CampaignOverview';

/**
 * 
 * @export
 * @interface AdAccountOverview
 */
export interface AdAccountOverview {
    /**
     * 
     * @type {string}
     * @memberof AdAccountOverview
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof AdAccountOverview
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdAccountOverview
     */
    statusName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdAccountOverview
     */
    status?: string;
    /**
     * 
     * @type {Array<CampaignOverview>}
     * @memberof AdAccountOverview
     */
    campaigns?: Array<CampaignOverview>;
}

/**
 * Check if a given object implements the AdAccountOverview interface.
 */
export function instanceOfAdAccountOverview(value: object): value is AdAccountOverview {
    return true;
}

export function AdAccountOverviewFromJSON(json: any): AdAccountOverview {
    return AdAccountOverviewFromJSONTyped(json, false);
}

export function AdAccountOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdAccountOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'status': json['status'] == null ? undefined : json['status'],
        'campaigns': json['campaigns'] == null ? undefined : ((json['campaigns'] as Array<any>).map(CampaignOverviewFromJSON)),
    };
}

export function AdAccountOverviewToJSON(json: any): AdAccountOverview {
    return AdAccountOverviewToJSONTyped(json, false);
}

export function AdAccountOverviewToJSONTyped(value?: AdAccountOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remoteId': value['remoteId'],
        'name': value['name'],
        'statusName': value['statusName'],
        'status': value['status'],
        'campaigns': value['campaigns'] == null ? undefined : ((value['campaigns'] as Array<any>).map(CampaignOverviewToJSON)),
    };
}

